import React from 'react';
import { useTheme } from 'emotion-theming';
export var AdsenseContext = /*#__PURE__*/React.createContext();
/**
 * @function AdsenseProvider
 * @param {boolean} adsense :: determines if ads are on
 * @param {boolean} adsenseMobile :: determines if mobile ads are on
 * @param {node} children :: children nodes
 */

export function AdsenseProvider(_ref) {
  var adsense = _ref.adsense,
      adsenseMobile = _ref.adsenseMobile,
      children = _ref.children;

  var _useTheme = useTheme(),
      MATCH_MEDIA = _useTheme.MATCH_MEDIA;

  var adsenseMediaQuery = adsenseMobile ? MATCH_MEDIA.XS : MATCH_MEDIA.M;
  return /*#__PURE__*/React.createElement(AdsenseContext.Provider, {
    value: {
      adsenseMediaQuery: adsenseMediaQuery,
      hasAdsense: adsense,
      hasAdsenseMobile: adsenseMobile
    }
  }, children);
}